angular.module('popup.client', ['popup', 'data.client']);